// Portfolio Highlights - Featured Success Stories (Adapted from iAngels style)

export const portfolioHighlights = [
  {
    id: 1,
    name: "Exscientia",
    tagline: "AI-Powered Drug Discovery",
    sector: "HealthTech / AI",
    description: "World's first AI-designed drug to enter clinical trials. Revolutionizing pharmaceutical development with machine learning.",
    logo: "https://ui-avatars.com/api/?name=Exscientia&background=EF4444&color=fff&size=200",
    status: "Successful Exit",
    highlight: "IPO on NASDAQ",
    founded: 2012,
    location: "Oxford, UK / Tel Aviv",
    investment_round: "Series C",
    key_metrics: {
      funding: "$525M raised",
      valuation: "$2.8B at IPO",
      achievement: "First AI-designed drug in clinical trials"
    }
  },
  {
    id: 2,
    name: "Arbe Robotics",
    tagline: "Next-Gen Radar for Autonomous Vehicles",
    sector: "Automotive / AI",
    description: "4D imaging radar technology enabling safe autonomous driving in all weather conditions.",
    logo: "https://ui-avatars.com/api/?name=Arbe&background=4F46E5&color=fff&size=200",
    status: "Public Company",
    highlight: "NASDAQ Listed",
    founded: 2015,
    location: "Tel Aviv, Israel",
    investment_round: "Series B",
    key_metrics: {
      funding: "$230M raised",
      valuation: "$1.4B",
      achievement: "Partnerships with major automotive OEMs"
    }
  },
  {
    id: 3,
    name: "Outdoorsy",
    tagline: "Airbnb for RVs",
    sector: "Travel Tech / Sharing Economy",
    description: "Peer-to-peer RV rental marketplace connecting owners with adventurers worldwide.",
    logo: "https://ui-avatars.com/api/?name=Outdoorsy&background=10B981&color=fff&size=200",
    status: "Growth Stage",
    highlight: "Market Leader",
    founded: 2015,
    location: "Austin, TX",
    investment_round: "Series D",
    key_metrics: {
      funding: "$300M+ raised",
      valuation: "$2B+",
      achievement: "3M+ rental nights booked"
    }
  },
  {
    id: 4,
    name: "eToro",
    tagline: "Social Trading Network",
    sector: "FinTech / Crypto",
    description: "Multi-asset investment platform enabling millions to trade stocks, crypto, and commodities.",
    logo: "https://ui-avatars.com/api/?name=eToro&background=F59E0B&color=fff&size=200",
    status: "Pre-IPO",
    highlight: "30M+ Users",
    founded: 2007,
    location: "Tel Aviv, Israel",
    investment_round: "Late Stage",
    key_metrics: {
      funding: "$800M+ raised",
      valuation: "$10B+",
      achievement: "Licensed in 140+ countries"
    }
  },
  {
    id: 5,
    name: "Immunai",
    tagline: "AI for Immune System Mapping",
    sector: "BioTech / AI",
    description: "Building the world's largest immune system database to accelerate drug development.",
    logo: "https://ui-avatars.com/api/?name=Immunai&background=8B5CF6&color=fff&size=200",
    status: "Growth Stage",
    highlight: "Unicorn Status",
    founded: 2018,
    location: "New York / Tel Aviv",
    investment_round: "Series B",
    key_metrics: {
      funding: "$370M raised",
      valuation: "$1B+",
      achievement: "300M+ immune cells mapped"
    }
  },
  {
    id: 6,
    name: "Lemonade",
    tagline: "AI-Powered Insurance",
    sector: "InsurTech / AI",
    description: "Transforming insurance with artificial intelligence and behavioral economics.",
    logo: "https://ui-avatars.com/api/?name=Lemonade&background=06B6D4&color=fff&size=200",
    status: "Public Company",
    highlight: "NYSE Listed",
    founded: 2015,
    location: "New York / Tel Aviv",
    investment_round: "IPO",
    key_metrics: {
      funding: "$480M raised",
      valuation: "$6B peak",
      achievement: "1.6M+ customers"
    }
  }
];

export const portfolioStats = {
  totalCompanies: 150,
  activeInvestments: 127,
  successfulExits: 24,
  unicorns: 8,
  publicCompanies: 5,
  averageGrowth: "185% YoY"
};

export const sectorBreakdown = [
  { sector: "AI & Machine Learning", percentage: 28, count: 42 },
  { sector: "FinTech", percentage: 18, count: 27 },
  { sector: "HealthTech & BioTech", percentage: 22, count: 33 },
  { sector: "Cybersecurity", percentage: 15, count: 23 },
  { sector: "CleanTech", percentage: 8, count: 12 },
  { sector: "Enterprise SaaS", percentage: 9, count: 13 }
];

export default portfolioHighlights;
